/* eslint-disable max-len */
import {
  useRecordContext,
  useRefresh,
  useTranslate,
  useUpdate
} from "react-admin";
// import { useParams } from "react-router-dom";
import { ShowInDialogButton } from "@react-admin/ra-form-layout";
import { muiColors } from "themes/colors";
import { CustomButton } from "./CustomButton";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface OrderConfirmationModalProps {
  isConfirmationModalOpen: string | null;
  setIsConfirmationModalOpen: React.Dispatch<
    React.SetStateAction<string | null>
  >;
}

export default function OrderConfirmationModal({
  isConfirmationModalOpen,
  setIsConfirmationModalOpen
}: OrderConfirmationModalProps) {
  const translate = useTranslate();
  const record = useRecordContext();
  const [edit] = useUpdate();
  // const { id } = useParams<{ id: string }>();
  const refresh = useRefresh();

  const handleAction = (
    argId: string,
    fieldName: string,
    fieldValue: string
  ) => {
    const updatedAppointment = {
      id: argId,
      data: {
        [fieldName]: fieldValue
      }
    };

    edit("Appointment", updatedAppointment, {
      onSuccess: () => {
        refresh();
      },
      onError: () => {
        // eslint-disable-next-line no-console
        console.error(`Error occurred during ${fieldName} action.`);
      }
    });
  };

  const handleRefund = () => {
    // todo refund
    setIsConfirmationModalOpen(null);
  };
  const handleCancel = () => {
    if (record?.appointmentId) {
      handleAction(
        record.appointmentId,
        "cancelled_at",
        new Date().toISOString()
      );
    }
    setIsConfirmationModalOpen(null);
  };

  return (
    // We are hiding dialog button because we are opening it with different button from different space
    <ShowInDialogButton
      title={
        isConfirmationModalOpen === "refund"
          ? translate("order.refund_funds")
          : translate("order.charge")
      }
      label=" "
      fullWidth
      ButtonProps={{
        value: translate("order.finish_order"),
        variant: "contained",
        startIcon: false,
        sx: { padding: 0, visibility: "hidden" }
      }}
      isOpen={Boolean(isConfirmationModalOpen)}
      onClose={() => setIsConfirmationModalOpen(null)}
      close={() => setIsConfirmationModalOpen(null)}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: muiColors.paper,
          borderRadius: "8px"
        },
        "& #edit-dialog-title": {
          textAlign: "center",
          textTransform: "uppercase",
          fontFamily: "Inter",
          fontSize: "14px"
        },
        "& .RaFormDialogTitle-closeButton": {
          display: "none"
        }
      }}
    >
      <div>
        {isConfirmationModalOpen === "refund" && (
          <div className="p-4">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
            <div className="flex justify-end mt-6">
              <CustomButton
                onClick={handleRefund}
                text={translate("order.refund")}
              />
            </div>
          </div>
        )}
        {isConfirmationModalOpen === "cancel" && (
          <div className="p-4">
            <p>
              Are you sure you want to cancel? This action can't be reversed, so
              please be certain before proceeding.
            </p>
            <div className="flex justify-end mt-6">
              <CustomButton
                onClick={handleCancel}
                text={translate("order.cancel")}
                sx={{
                  backgroundColor: muiColors.error,
                  "&:hover": {
                    backgroundColor: muiColors.error,
                    opacity: 0.9
                  }
                }}
              />
            </div>
          </div>
        )}
        <IconButton
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px"
          }}
          onClick={() => setIsConfirmationModalOpen(null)}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </ShowInDialogButton>
  );
}
